// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { register } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Register service worker for offline-first PWA
register({
  onUpdate: registration => {
    // Notify user that a new version is available
    const event = new CustomEvent('sw:update', { detail: registration });
    window.dispatchEvent(event);
  },
});
